<template>
  <div class="app-container">
    <div class="card">
      <el-form ref="form" :model="queryParams" :inline="true">
        <el-form-item label="审核日期：">
          <el-date-picker
            v-model="queryParams.datelist"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期 "
            end-placeholder="结束日期"
            unlink-panels
            clearable
            @change="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">
            搜 索
          </el-button>
          <el-button icon="el-icon-delete" @click="handleReset">
            重 置
          </el-button>
        </el-form-item>
      </el-form>
      <div style="margin-bottom: 10px">
        <el-button type="primary" icon="el-icon-download" @click="updowning">
          导 出
        </el-button>
      </div>
    </div>
    <div class="mainContainer">
      <!-- 列表 -->
      <div class="table-container">
        <el-table v-loading="loading" :data="tableData" border height="100%">
          <el-table-column
            prop="platformUserId"
            label="用户id"
            align="center"
          />
          <el-table-column
            prop="platformUserName"
            label="用户姓名"
            align="center"
          />
          <el-table-column
            prop="customerAuditCount"
            label="客户首营审核数量"
            align="center"
          />
          <el-table-column
            prop="customerScopeCount"
            label="客户资料编辑数量"
            align="center"
          />
          <el-table-column
            prop="sharedReceiveAuditCount"
            label="共享接收审核数量"
            align="center"
          />
          <el-table-column prop="auditDate" label="审核日期" align="center" />
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.currPage"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import {
  getCustomerStatisticsList, //客户数据统计列表
} from "@/api/appApi/appapi.js";
import { downLoadZip } from "@/utils/zipdownload";
export default {
  name: "",
  data() {
    return {
      queryParams: {
        currPage: 1, // 页码
        pageSize: 10, //每页大小
        datelist: [], //审核日期
        startTime: "", //开始时间
        endTime: "", //结束时间
      },
      total: 0,
      loading: false,
      tableData: [], //列表

      dialogVisible: false, //经营管理更新弹窗
    };
  },

  created() {
    if (this.$route.query) {
      console.log(this.$route.query, "this.$route.query");
    }
    this.getList();
  },
  methods: {
    //序号
    indexMethod(index) {
      index + (this.queryParams.currPage - 1) * this.queryParams.pageSize + 1;
    },

    /** 查询列表数据 */
    async getList() {
      if (this.queryParams.datelist && this.queryParams.datelist.length > 0) {
        this.queryParams.startTime = this.queryParams.datelist[0];
        this.queryParams.endTime = this.queryParams.datelist[1];
      } else {
        this.queryParams.startTime = "";
        this.queryParams.endTime = "";
      }
      let params = { ...this.queryParams };
      delete params.datelist;
      this.loading = true;
      let res = await getCustomerStatisticsList(params);
      this.loading = false;
      if (res.code == "000000") {
        this.tableData = res.content.list;
        this.total = res.content.totalRecords;
      }
    },
    //查询按钮操作
    handleQuery() {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置
    handleReset() {
      Object.assign(this.queryParams, this.$options.data().queryParams);
      this.getList();
    },
    /** 导出 */
    updowning() {
      let params = { ...this.queryParams };
      delete params.datelist;
      downLoadZip(
        "/cloudWisdom/cloud/data/exportCustomerStatisticsList",
        "xlsx",
        "客户数据统计导出",
        params,
        "app",
        "get"
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
